module.exports = ":root{--lui-navigation-height:var(--lui-raised-control-height)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-navigation/theme/lui-navigation.global.scss
// module id = 256
// module chunks = 0 1 9